export enum StakingPool {
  WarsBusdLp = "WARS-BUSD-LP",
  Wars = "WARS",
  WxMStakingW = "WxMStakingW",
  WarsBusdLp1 = "WARS-BUSD-LP1",
  WarsBusdLp2 = "WARS-BUSD-LP2",
  WarsBusdLpGAM = "WARS-BUSD-LP GAM",
  
}
